import { Component, OnInit, ViewChild } from '@angular/core';
import { CRMHierarquiaUsuario } from '../models/crmhierarquia-usuario';
import { GlobalService } from '../services/global.service';
import { FuncionarioService } from '../services/funcionario.service';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { CRMHierarquiaUsuarioService } from '../services/crmhierarquia-usuario.service';
import { GerenciarColunasCarteiraIntegradoresModalComponent } from '../modals/gerenciar-colunas-carteira-integradores-modal/gerenciar-colunas-carteira-integradores-modal.component';
import { MatDialog, PageEvent, MatPaginator, MatTabGroup } from '@angular/material';
import { GerenciarFiltrosCarteiraIntegradoresModalComponent } from '../modals/gerenciar-filtros-carteira-integradores-modal/gerenciar-filtros-carteira-integradores-modal.component';
import { SelecionarConsultaCarteiraIntegradoresModalComponent } from '../modals/selecionar-consulta-carteira-integradores-modal/selecionar-consulta-carteira-integradores-modal.component';
import { CarteiraDeIntegradoresService } from '../services/carteira-de-integradores.service';
import { SelecionarTagModalComponent } from '../modals/selecionar-tag-modal/selecionar-tag-modal.component';
import { TipoTag, TipoRankingCarteira, TipoEstatisticaCarteira } from '../models/enum';
import { TagGiService } from '../services/tag-gi.service';

import { UtilitarioService } from '../services/utilitario.service';
import { DadosDoIntegradorCarteiraIntegradoresModalComponent } from '../modals/dados-do-integrador-carteira-integradores-modal/dados-do-integrador-carteira-integradores-modal.component';
import { AtividadeModalComponent } from '../modals/atividade-modal/atividade-modal.component';
import { GerenciarClassificacaoPersonalizadaModalComponent } from '../modals/gerenciar-classificacao-personalizada-modal/gerenciar-classificacao-personalizada-modal.component';
import { ClienteService } from '../services/cliente.service';
import { CarteiraDeIntegradoresEstatisticasFiltro } from '../models/carteira-de-integradores-estatisticas-filtro';
import { CarteiraDeIntegradoresEstatisticas } from '../models/carteira-de-integradores-estatisticas';
import { CarteiraDeIntegradoresRankingFiltro } from '../models/carteira-de-integradores-ranking-filtro';
import { CarteiraDeIntegradoresItemRanking } from '../models/carteira-de-integradores-item-ranking';
import { CarteiraDeIntegradoresTelemarketing } from '../models/carteira-de-integradores-telemarketing';
import { CadastrarLigacaoTelemarketingModalComponent } from '../modals/cadastrar-ligacao-telemarketing-modal/cadastrar-ligacao-telemarketing-modal.component';
import { LigacaoModalComponent } from '../modals/ligacao-modal/ligacao-modal.component';
import { PremissasService } from '../services/premissas.service';
import { ClientesModalComponent } from '../modals/clientes-modal/clientes-modal.component';
import swal from 'sweetalert2';
import { ContatoAnexoModalComponent } from '../modals/contato-anexo-modal/contato-anexo-modal.component';
import { Router } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { AutenticacaoService } from '../services/autenticacao.service';
import { UsuarioLogado } from '../models/usuario-logado';
import { PaginatorService } from '../services/paginator.service';
import { PremissasSistema } from '../models/premissas-sistema';
import { TermoAceiteListaModalComponent } from '../modals/termo-aceite-lista-modal/termo-aceite-lista-modal.component';

declare const $: any;

@Component({
  selector: 'app-carteira-de-integradores',
  templateUrl: './carteira-de-integradores.component.html',
  styleUrls: ['./carteira-de-integradores.component.scss']
})
export class CarteiraDeIntegradoresComponent implements OnInit {
  periodoSelecionado = 5;
  vendedorSelecionado = 0;
  idFiltro;
  descricaoFiltro;

  periodos = [
    { id: 1, name: 'Hoje' },
    { id: 2, name: 'Ontem' },
    { id: 3, name: 'Esta semana' },
    { id: 4, name: 'Semana passada' },
    { id: 5, name: 'Este mês' },
    { id: 6, name: 'Mês Passado' },
    { id: 7, name: 'Ultimos 60 dias' },
    { id: 8, name: 'Personalizado' },
    { id: 9, name: 'Últimos 3 Meses' },
    { id: 10, name: 'Últimos 6 Meses' },
    { id: 11, name: 'Ano Atual' }
  ];

  vendedores: CRMHierarquiaUsuario[] = [];
  integradores = [];
  administrador = false;
  colunasSelecionadas = [];
  pInicio;
  pFim;

  tiposPesquisa = [{ id: 0, nome: 'Documento' }, { id: 1, nome: 'Fantasia' }, { id: 2, nome: 'Razão' }, { id: 3, nome: 'Email' }];
  tipoPesquisaSelecionado: number;
  tipoPesquisaTelemarketingSelecionado: number;
  pesquisa: string;
  pesquisaTelemarketing: string;

  trocarRazaoPorNomeFantasia = false;

  filtrosSelecionados = [];

  editavel = true;

  paginacaoBI = {
    campoOrdenacao: 'codErp',
    ordenarDesc: false,
    paginacao: { tamanhoMaximo: 10, total: 0, paginaAtual: 1 },
    listaDeItensPorPagina: [10, 30, 50],
    itensPorPagina: 10,
  };

  paginacaoTelemarketing = {
    campoOrdenacao: 'ultimaligacao',
    ordenarDesc: false,
    paginacao: { tamanhoMaximo: 10, total: 0, paginaAtual: 1 },
    listaDeItensPorPagina: [10, 30, 50],
    itensPorPagina: 10,
  };

  colunasOpcionaisSelecionadas = [];
  verExcel = false;
  showStats = false;

  estatisticas: CarteiraDeIntegradoresEstatisticas;

  tipoRankingSelecionado = TipoRankingCarteira.Paineis;

  ranking: { name: string, value: number }[];

  showDashboard = false;
  showRanking = false;
  showBI = false;
  showTelemarketing = false;

  tipoStatsSelecionado = TipoEstatisticaCarteira.Integradores;

  telemarketingIntegradores: CarteiraDeIntegradoresTelemarketing[] = [];

  rankingColorScheme = {
    domain: ['#f5a505'],
  };

  possuiLigacao = true;

  pesquisaPorTimes = false;

  mostrarPesquisaGeral = false;

  modulosAtivos: Number[] = [];

  usuarioLogado: UsuarioLogado;

  premissasSistema = new PremissasSistema();

  @ViewChild('paginatorBI', { static: false }) paginatorBI: MatPaginator;
  @ViewChild('paginatorTelemarketing', { static: false }) paginatorTelemarketing: MatPaginator;

  @ViewChild('paginacaoStats', { static: false }) tabGroupStats: MatTabGroup;
  @ViewChild('paginacaoRanking', { static: false }) tabGroupRanking: MatTabGroup;

  constructor(
    private globalService: GlobalService,
    private funcionarioService: FuncionarioService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private hierarquiaService: CRMHierarquiaUsuarioService,
    private utilitarioService: UtilitarioService,
    private carteiraDeIntegradoresService: CarteiraDeIntegradoresService,
    private dialog: MatDialog,
    private tagService: TagGiService,
    private clienteService: ClienteService,
    private premissasService: PremissasService,
    private platformLocation: PlatformLocation,
    private autenticacaoService: AutenticacaoService,
    private router: Router
  ) { }

  async ngOnInit() {
    this.usuarioLogado = await this.globalService.consultaUsuario();

    await this.buscarModulosAtivos();

    this.buscarPremissasSistema();

    this.administrador = await this.globalService.administrador();
    this.verExcel = this.usuarioLogado.verExcel;

    this.buscarMostrarPesquisaGeral();

    this.buscarVendedores();
    this.buscarTrocarRazaoPorNomeFantasia();

    this.toggleBI();
  }

  irParaRzk(idIntegrador) {
    this.router.navigate(['/energy-advisor/integrador', idIntegrador]);
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');

    this.premissasService.consultarPremissasSistema().subscribe(
      (premissas) => {
        this.premissasSistema = premissas;
        this.carregandoService.esconde('buscarPremissasSistema');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      }
    );
  }

  limparConsulta() {
    this.filtrosSelecionados = [];
    this.colunasOpcionaisSelecionadas = [];
    this.colunasSelecionadas = [];
    this.descricaoFiltro = undefined;
    this.idFiltro = undefined;
  }

  ordenaBI(campo) {
    if (campo) {
      this.paginacaoBI.campoOrdenacao = campo;
      this.paginacaoBI.ordenarDesc = !this.paginacaoBI.ordenarDesc;

      this.mudaDePaginaBI({ length: this.paginatorBI.length, pageIndex: this.paginatorBI.pageIndex, pageSize: this.paginatorBI.pageSize });
    }

    return false;
  }

  ordenaTelemarketing(campo) {
    return false;
  }

  mudaDePaginaBI(pageEvent: PageEvent) {
    this.paginacaoBI.itensPorPagina = pageEvent.pageSize;
    this.paginacaoBI.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarDados();
  }

  mudaDePaginaTelemarketing(pageEvent: PageEvent) {
    this.paginacaoTelemarketing.itensPorPagina = pageEvent.pageSize;
    this.paginacaoTelemarketing.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarDados();
  }

  buscarTelemarketing() {
    if (this.pesquisaPorTimes || (this.periodoSelecionado === 8 && (!this.pInicio || !this.pFim))) {
      return;
    }

    this.carregandoService.mostra('buscarTelemarketing');

    let inicio: any;
    let fim: any;

    if (this.periodoSelecionado === 8) {
      if (this.pInicio && this.pFim) {
        inicio = typeof this.pInicio !== 'string' ? this.pInicio.toISOString() : this.pInicio;
        fim = typeof this.pFim !== 'string' ? this.pFim.toISOString() : this.pFim;
      }
    }

    this.carteiraDeIntegradoresService.consultarTelemarketingComPaginacao(
      {
        tipoPesquisaTelemarketing: this.tipoPesquisaTelemarketingSelecionado,
        pesquisaTelemarketing: this.pesquisaTelemarketing,
        tipoFiltroPeriodo: this.periodoSelecionado,
        inicio,
        fim,
        idVendedor: this.vendedorSelecionado ? this.vendedorSelecionado : undefined,
        possuiLigacao: this.possuiLigacao,
        pag: this.paginacaoTelemarketing.paginacao.paginaAtual,
        qt: this.paginacaoTelemarketing.itensPorPagina,
        ordem: this.paginacaoTelemarketing.campoOrdenacao,
        asc_desc: this.paginacaoTelemarketing.ordenarDesc ? 'desc' : 'asc'
      }).subscribe(
        (result) => {
          if (result.itens !== undefined && result.itens !== null) {
            this.telemarketingIntegradores = result.itens;

            if (this.paginacaoTelemarketing.itensPorPagina > this.paginacaoTelemarketing.listaDeItensPorPagina[this.paginacaoTelemarketing.listaDeItensPorPagina.length - 1]) {
              this.paginacaoTelemarketing.itensPorPagina = 10;
            }

            this.paginacaoTelemarketing.paginacao.total = result.total;
          }

          this.carregandoService.esconde('buscarTelemarketing');
        },
        (erro) => {
          this.carregandoService.esconde('buscarTelemarketing');
          this.notificacaoService.erro(erro);
        });
  }

  buscarColunas() {
    this.carregandoService.mostra('buscarColunas');

    this.carteiraDeIntegradoresService.consultarColunasOpcionais().subscribe(
      (colunas) => {
        this.colunasOpcionaisSelecionadas = [];

        this.colunasOpcionaisSelecionadas = colunas.filter(p => this.colunasSelecionadas.find(c => p.id === c));

        this.carregandoService.esconde('buscarColunas');
      },
      (erro) => {
        this.carregandoService.esconde('buscarColunas');
        this.notificacaoService.erro(erro);
      }
    );
  }

  toggleDashboard() {
    this.showDashboard = !this.showDashboard;

    if (this.showDashboard) {
      $('#collapseDashboard').addClass('show');
    } else {
      $('#collapseDashboard').removeClass('show');
    }
  }

  toggleStats() {
    this.showStats = !this.showStats;

    if (this.showStats) {
      $('#collapseStats').addClass('show');
    } else {
      $('#collapseStats').removeClass('show');
    }

    if (this.showStats) {
      this.buscarEstatisticas();
    }
  }

  toggleRanking() {
    this.showRanking = !this.showRanking;

    if (this.showRanking) {
      $('#collapseRanking').addClass('show');
    } else {
      $('#collapseRanking').removeClass('show');
    }

    if (this.showRanking) {
      this.buscarRanking();
    }
  }

  toggleBI() {
    this.showBI = !this.showBI;

    if (this.showBI) {
      $('#collapseBI').addClass('show');
    } else {
      $('#collapseBI').removeClass('show');
    }

    if (this.showRanking) {
      this.buscarRanking();
    }
  }

  toggleTelemarketing() {
    this.showTelemarketing = !this.showTelemarketing;

    if (this.showTelemarketing) {
      $('#collapseTelemarketing').addClass('show');
    } else {
      $('#collapseTelemarketing').removeClass('show');
    }

    if (this.showTelemarketing) {
      this.buscarTelemarketing();
    }
  }

  private montaVM(): {
    tipoFiltroPeriodo: number,
    inicio?: Date,
    fim?: Date,
    idVendedor?: number,
    filtros: any[],
    colunas: any[],
    pag: number,
    qt: number,
    ordem: string,
    asc_desc: string,
    tipoPesquisa: number,
    pesquisa: string
  } {
    return {
      filtros: this.filtrosSelecionados,
      colunas: this.colunasSelecionadas,
      tipoFiltroPeriodo: this.periodoSelecionado,
      idVendedor: this.vendedorSelecionado !== 0 ? this.vendedorSelecionado : undefined,
      pag: this.paginacaoBI.paginacao.paginaAtual,
      qt: this.paginacaoBI.itensPorPagina,
      ordem: this.paginacaoBI.campoOrdenacao,
      asc_desc: this.paginacaoBI.ordenarDesc ? 'desc' : 'asc',
      tipoPesquisa: this.tipoPesquisaSelecionado,
      pesquisa: this.pesquisa
    };
  }

  conversarPeloWhatsApp(telefone) {
    this.utilitarioService.conversarPeloWhatsapp(telefone, '');
  }

  buscarDados() {
    this.buscarTelemarketing();
    this.buscarDadosBI();
  }

  buscarDadosBI() {
    if (this.periodoSelecionado === 8 && (!this.pInicio || !this.pFim)) {
      return;
    }

    if (!this.pesquisaPorTimes) {

      this.buscarColunas();

      const vm = this.montaVM();

      if (this.periodoSelecionado === 8) {
        if (this.pInicio && this.pFim) {
          vm.inicio = typeof this.pInicio !== 'string' ? this.pInicio.toISOString() : this.pInicio;
          vm.fim = typeof this.pFim !== 'string' ? this.pFim.toISOString() : this.pFim;
        }
      }

      this.carregandoService.mostra('buscaIntegradores');

      this.carteiraDeIntegradoresService.consultarComPaginacao(vm).subscribe(dados => {
        this.integradores = dados.itens;

        if (this.paginacaoBI.itensPorPagina > this.paginacaoBI.listaDeItensPorPagina[this.paginacaoBI.listaDeItensPorPagina.length - 1]) {
          this.paginacaoBI.itensPorPagina = 10;
        }

        this.paginacaoBI.paginacao.total = dados.total;

        this.carregandoService.esconde('buscaIntegradores');
      }, (erro) => {
        this.carregandoService.esconde('buscaIntegradores');
        this.notificacaoService.erro(erro);
      });
    }

    if (this.showStats) {
      this.buscarEstatisticas(this.tipoStatsSelecionado - 1);
    }

    if (this.showRanking) {
      this.buscarRanking(this.tipoRankingSelecionado - 1);
    }
  }

  onSelect(event) {
  }

  buscarEstatisticas(tipoStats?) {
    this.estatisticas = undefined;

    this.carregandoService.mostra('buscarEstatisticas');

    let vm = new CarteiraDeIntegradoresEstatisticasFiltro();

    if (this.periodoSelecionado === 8) {
      if (this.pInicio && this.pFim) {
        vm.inicio = typeof this.pInicio !== 'string' ? this.pInicio.toISOString() : this.pInicio;
        vm.fim = typeof this.pFim !== 'string' ? this.pFim.toISOString() : this.pFim;
      }
    } else {
      vm.inicio = undefined;
      vm.fim = undefined;
    }

    vm.tipoFiltroPeriodo = this.periodoSelecionado;
    vm.pesquisaPorTimes = this.pesquisaPorTimes;

    vm.idVendedor = this.vendedorSelecionado !== 0 ? this.vendedorSelecionado : undefined;

    if (tipoStats === undefined || tipoStats === null) {
      this.tipoStatsSelecionado = 1;
    } else {
      this.tipoStatsSelecionado = tipoStats + 1;
    }

    vm.tipoEstatistica = this.tipoStatsSelecionado;

    this.carteiraDeIntegradoresService.consultarEstatisticas(vm).subscribe(dados => {
      this.estatisticas = dados;

      this.tabGroupStats.selectedIndex = this.tipoStatsSelecionado - 1;

      this.carregandoService.esconde('buscarEstatisticas');
    }, (erro) => {
      this.carregandoService.esconde('buscarEstatisticas');
      this.notificacaoService.erro(erro);
    }
    );
  }

  buscarRanking(tipoRanking?) {
    this.ranking = undefined;

    this.carregandoService.mostra('buscarRanking');

    let vm = new CarteiraDeIntegradoresRankingFiltro();

    if (this.periodoSelecionado === 8) {
      if (this.pInicio && this.pFim) {
        vm.inicio = typeof this.pInicio !== 'string' ? this.pInicio.toISOString() : this.pInicio;
        vm.fim = typeof this.pFim !== 'string' ? this.pFim.toISOString() : this.pFim;
      }
    }

    vm.pesquisaPorTimes = this.pesquisaPorTimes;
    vm.tipoFiltroPeriodo = this.periodoSelecionado;
    vm.idVendedor = this.vendedorSelecionado !== 0 ? this.vendedorSelecionado : undefined;

    if (tipoRanking === undefined || tipoRanking === null) {
      this.tipoRankingSelecionado = 1;
    } else {
      this.tipoRankingSelecionado = tipoRanking + 1;
    }

    vm.tipoRanking = this.tipoRankingSelecionado;

    this.carteiraDeIntegradoresService.consultarRanking(vm).subscribe(dados => {
      this.ranking = dados.map(p => ({ name: p.descricao, value: p.valor }));

      this.tabGroupRanking.selectedIndex = this.tipoRankingSelecionado - 1;

      this.carregandoService.esconde('buscarRanking');
    }, (erro) => {
      this.carregandoService.esconde('buscarRanking');
      this.notificacaoService.erro(erro);
    }
    );
  }

  exportar() {
    const vm = this.montaVM();

    if (this.periodoSelecionado === 8) {
      if (this.pInicio && this.pFim) {
        vm.inicio = typeof this.pInicio !== 'string' ? this.pInicio.toISOString() : this.pInicio;
        vm.fim = typeof this.pFim !== 'string' ? this.pFim.toISOString() : this.pFim;
      }
    }

    this.carregandoService.mostra('exportar');
    this.carteiraDeIntegradoresService.exportar(vm).subscribe(
      (arq) => {
        this.utilitarioService.saveBlob(arq, 'CarteiraDeIntegradores.xlsx');
        this.carregandoService.esconde('exportar');
      },
      (err) => {
        this.carregandoService.esconde('exportar');
        this.notificacaoService.erro(err);
      }
    );
  }

  classificacaoPersonalizada(idCliente) {
    this.carregandoService.mostra('buscaCliente');

    this.clienteService.consultarPorIdCliente(idCliente, true).subscribe(cli => {
      if (cli) {
        const largura = Number(($('body').width()));

        const dialogRef = this.dialog.open(GerenciarClassificacaoPersonalizadaModalComponent, {
          width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
          data: {
            tabelas: cli.camposPersonalizadosMontar,
            editavel: true,
            mostrarClassificacao: true,
            classificacaoSelecionada: cli.segm
          },
          panelClass: 'modal-card'
        });

        dialogRef.afterClosed().subscribe((result: any) => {
          if (result) {
            cli.segm = Number(result.classificacaoSelecionada);
            cli.camposPersonalizadosMontar = result.tabelas;

            this.carregandoService.mostra('salvaCliente');

            this.clienteService.atualizar(cli).subscribe(() => {
              this.notificacaoService.sucesso('Integrador atualizado com sucesso!!!');
              this.carregandoService.esconde('salvaCliente');

            }, (erro) => {
              this.carregandoService.esconde('salvaCliente');
              this.notificacaoService.erro(erro);
            });
          }
        });
      }
      this.carregandoService.esconde('buscaCliente');
    }, (erro) => {
      this.carregandoService.esconde('buscaCliente');
      this.notificacaoService.erro(erro);
    });
  }

  alterouPesquisarPorTimes() {
    this.buscarVendedores(true);
  }

  buscarTrocarRazaoPorNomeFantasia() {
    this.carregandoService.mostra('buscarTrocarRazaoPorNomeFantasia');
    this.premissasService.consultarTrocarRazaoPorNomeFantasia().subscribe(fg => {
      if (fg.valor) {
        this.trocarRazaoPorNomeFantasia = fg;
      }

      this.carregandoService.esconde('buscarTrocarRazaoPorNomeFantasia');
    }, (erro) => {
      this.carregandoService.esconde('buscarTrocarRazaoPorNomeFantasia');
      this.notificacaoService.erro(erro);
    });
  }

  abrirAtividadesDoIntegrador(idCliente) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(AtividadeModalComponent, {
      width: largura > 1050 ? '1000px' : (($('body').width()).toString() + 'px'),
      data: {
        idCliente: idCliente,
      },
      panelClass: 'modal-card',
    });
  }

  abrirDadosIntegrador(idCliente) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(DadosDoIntegradorCarteiraIntegradoresModalComponent, {
      width: largura > 1050 ? '1000px' : (($('body').width()).toString() + 'px'),
      data: {
        idCliente: idCliente,
      },
      panelClass: 'modal-card',
    });
  }

  buscarVendedores(pesquisar?) {
    if (!this.pesquisaPorTimes && this.administrador) { // || !this.usuarioLogado.verSomenteHierarquia)) {
      this.carregandoService.mostra('buscarVendedores');

      this.funcionarioService.consultarFuncionariosPedido(null, true).subscribe(resp => {
        this.vendedores = resp.map(p => ({ idFuncion: Number(p.idFuncion), nome: p.nome }));
        if (this.vendedores.length > 1) {
          this.vendedores.unshift({ idFuncion: 0, nome: 'Todos' });
        }

        if (pesquisar) {
          this.vendedorSelecionado = this.vendedores[0].idFuncion;
          this.buscarDados();
        }
        this.carregandoService.esconde('buscarVendedores');
      }, (erro) => {
        this.carregandoService.esconde('buscarVendedores');
        this.notificacaoService.erro(erro);
      });
    }
    else {
      this.carregandoService.mostra('buscaUsuarios');

      this.hierarquiaService.consultarHierarquiaDoUsuarioLista(undefined, this.pesquisaPorTimes, true).subscribe(resp => {
        this.vendedores = resp;

        if (this.vendedores.some(p => p.idFuncion === Number(this.usuarioLogado.id))) {
          this.vendedores.splice(this.vendedores.
            indexOf(this.vendedores.find(p => p.idFuncion === Number(this.usuarioLogado.id))), 1);
        }

        if (this.vendedores.length > 0) {
          const todos = new CRMHierarquiaUsuario();
          todos.idFuncion = 0;
          todos.nome = 'Todos';
          this.vendedores.unshift(todos);
        } else {
          this.vendedorSelecionado = -1;
          this.buscarDados();
        }

        const somenteEu = new CRMHierarquiaUsuario();
        somenteEu.idFuncion = -1;
        somenteEu.nome = 'Somente eu';
        this.vendedores.unshift(somenteEu);

        if (pesquisar) {
          this.vendedorSelecionado = this.vendedores[0].idFuncion;
          this.buscarDados();
        }

        this.carregandoService.esconde('buscaUsuarios');
      }, (erro) => {
        this.carregandoService.esconde('buscaUsuarios');
        this.notificacaoService.erro(erro);
      });
    }
  }

  abrirModalLigacao(intTele) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarLigacaoTelemarketingModalComponent, {
      width: largura > 950 ? '900px' : (($('body').width()).toString() + 'px'),
      data: {
        intTele
      },
      panelClass: 'modal-card',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.buscarTelemarketing();
    });
  }

  abrirModalDadosDaLigacao(idLigacao) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(LigacaoModalComponent, {
      width: largura > 950 ? '900px' : (($('body').width()).toString() + 'px'),
      data: {
        idLigacao: idLigacao
      },
      panelClass: 'modal-card',
    });

    dialogRef.afterClosed().subscribe(result => {
    });

    return false;
  }

  abrirModalGerenciarColunas() {
    const dialogRef = this.dialog.open(GerenciarColunasCarteiraIntegradoresModalComponent, {
      width: '350px',
      data: { colunasSelecionadas: this.colunasSelecionadas },
      panelClass: 'modal-card',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.colunasSelecionadas = result;
        this.buscarDados();
      }
    });
  }

  abrirModalGerenciarFiltros() {
    const dialogRef = this.dialog.open(GerenciarFiltrosCarteiraIntegradoresModalComponent, {
      width: '600px',
      data: {
        idFiltro: this.idFiltro,
        descricaoFiltro: this.descricaoFiltro,
        vendedorSelecionado: this.vendedorSelecionado,
        filtrosSelecionados: this.filtrosSelecionados,
        colunasSelecionadas: this.colunasSelecionadas
      },
      panelClass: 'modal-card',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.filtrosSelecionados = result.filtrosSelecionados;
        this.descricaoFiltro = result.descricaoFiltro;
        this.idFiltro = result.idFiltro;
        this.buscarDados();
      }
    });
  }

  possuiModulo(modulo: Number) {
    return this.modulosAtivos.some(p => p === modulo);
  }

  async buscarModulosAtivos() {

    try {
      this.carregandoService.mostra('buscarModulosAtivos');

      this.modulosAtivos = await this.premissasService.consultarModulosAtivos().toPromise();

      this.carregandoService.esconde('buscarModulosAtivos');
    } catch (erro) {
      this.carregandoService.esconde('buscarModulosAtivos');
      this.notificacaoService.erro(erro);
    }
  }

  abrirModalSelecionarConsulta() {
    const dialogRef = this.dialog.open(SelecionarConsultaCarteiraIntegradoresModalComponent, {
      width: '600px',
      data: {
        idVendedor: this.vendedorSelecionado,
        idFiltro: this.idFiltro,
        descricaoFiltro: this.descricaoFiltro
      },
      panelClass: 'modal-card',
      // maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.idFiltro = result.idFiltro;
        this.descricaoFiltro = result.descricaoFiltro;
        this.filtrosSelecionados = result.filtrosSelecionados;
        this.colunasSelecionadas = result.colunasSelecionadas;

        this.buscarDados();
      }
    });
  }

  tags(integrador: any) {
    this.carregandoService.mostra('buscarTags');

    this.tagService.consultarPorIdIntegrador(integrador.idCliente).subscribe(
      (tags) => {
        const largura = Number(($('body').width()));

        const dialogRef = this.dialog.open(SelecionarTagModalComponent, {
          width: largura > 850 ? '800px' : (($('body').width()).toString() + 'px'),
          data: { idIntegrador: integrador.idCliente, tags: tags.map(t => t.id), tipo: TipoTag.integrador },
          panelClass: 'modal-card'
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result) { }
        });

        this.carregandoService.esconde('buscarTags');
      },
      (erro) => {
        this.carregandoService.esconde('buscarTags');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarMostrarPesquisaGeral() {
    this.carregandoService.mostra('consultarMostrarPesquisaGeral');
    this.premissasService.consultarMostrarPesquisaGeral().subscribe(
      (f) => {
        this.mostrarPesquisaGeral = f.valor;

        this.carregandoService.esconde('consultarMostrarPesquisaGeral');
      },
      (erro) => {
        this.carregandoService.esconde('consultarMostrarPesquisaGeral');
        this.notificacaoService.erro(erro);
      }
    );
  }

  pesquisaGeralCliente() {
    const dialogRef = this.dialog.open(ClientesModalComponent, {
      width: ($('body').width()).toString() + 'px',
      data: {
        gi: 1,
        esconderBotao: true,
        pesquisaGeral: true
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) { }
    }
    );
  }

  bloquearIntegrador(integrador) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente bloquear esse integrador?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('bloquearIntegrador');

        this.clienteService.bloquear(integrador.idCliente).subscribe(resp => {
          this.carregandoService.esconde('bloquearIntegrador');
          this.notificacaoService.sucesso('Integrador bloqueado com sucesso!!!');
          this.buscarDados();
        }, (erro) => {
          this.carregandoService.esconde('bloquearIntegrador');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  ativarIntegrador(integrador) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente ativar esse integrador?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('ativarIntegrador');

        this.clienteService.ativar(integrador.idCliente).subscribe(resp => {
          this.carregandoService.esconde('ativarIntegrador');
          this.notificacaoService.sucesso('Integrador ativado com sucesso!!!');
          this.buscarDados();
        }, (erro) => {
          this.carregandoService.esconde('ativarIntegrador');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  anexos(integrador) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(ContatoAnexoModalComponent, {
      width: (($('body').width()).toString() + 'px'),
      data: {
        idContato: integrador.idGIContato,
        statusSelecionado: true,
        podeEditar: true
      },
      panelClass: 'modal-card'
    });
  }

  reenviarEmail(integrador) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente Reenviar o Email para liberação de acesso desse Integrador?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('resetandoSenha');

        const url = location.origin + this.platformLocation.getBaseHrefFromDOM();

        this.autenticacaoService.esqueceuSenha(integrador.email, url).subscribe((data: any) => {
          this.notificacaoService.sucesso(
            'Email Reenviado com sucesso!!!');

          this.router.navigate(['/']).then(() => {
            this.carregandoService.esconde('resetandoSenha');
          });

        }, (erro: any) => {
          this.notificacaoService.erro(erro);
          this.carregandoService.esconde('resetandoSenha');
        });
      }
    });
  }

  abrirModalAceiteTermo(idIntegrador) {
    const largura = Number(($('body').width()));

    this.dialog.open(TermoAceiteListaModalComponent, {
      width: largura > 970 ? '870px' : (($('body').width()).toString() + 'px'),
      panelClass: 'modal-card',
      data: { tipoVisualizacao: 2, tipoUsuario: 1, idUsuario: idIntegrador }
    });
  }
}
